import { use } from 'react'
import { GlobalContext } from '../context/global'
import { PersonalPageContext } from '../context/personal-page'
import { PrioritySettingsContext } from '../context/priority-settings'
import { BookingViewContext } from '@/context/booking-view'
import { KosmotimeStateContext } from '@/context/kosmotime'

export { useAutoSaveState } from '@chilipiper/meeting-type-components'

export const useGlobalState = () => {
  return use(GlobalContext)
}

export const useBookingViewState = () => {
  return use(BookingViewContext)
}

export const usePersonalPageState = () => {
  return use(PersonalPageContext)
}

export const usePrioritySettingsState = () => {
  const context = use(PrioritySettingsContext)

  if (!context) {
    throw new Error('usePrioritySettingsState must be used within a PrioritySettingsProvider')
  }

  return use(PrioritySettingsContext)
}

export const useKosmotimeState = () => {
  const context = use(KosmotimeStateContext)

  if (!context) {
    throw new Error('useKosmotimeState must be used within a KosmotimeStateProvider')
  }

  return use(KosmotimeStateContext)
}
